<template>
    <div>
        <div class="header" style="padding-top: 0">
            <div class="title">IP白名单设置</div>
        </div>
        <div class="multiple">
			<Input v-model="ipaddress" placeholder="请输入IP,支持通配符*"  style="width: 300px" />
            <div class="setMoney">
                <Button  type="primary" @click="saveIpAddress">添加</Button>
            </div>
        </div>
        <div class="multiple" v-for="(item, index) in ipList">
            <!--div style="width: 150px; text-align: center">{{item.ipaddress}}</div-->
			
			<Input v-model="item.ipaddress"  style="width: 250px ;margin: 0 20px;"></Input>
			<div >
			    <Button  :data-id="item.id" :data-ipaddress="item.ipaddress" @click="editIpAddress">修改</Button>
			</div>
            <div style="padding-left: 30px;">
                <Button  :data-id="item.id" @click="delIpaddress">删除</Button>
            </div>
        </div>

    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import {getIpAddress,saveIpAddress,delIpaddress} from "../../api/task";

    export default {
        name: 'IpSet',
        computed: {
            ...mapGetters(['token', 'userInfo'])
        },
        mounted() {
            this.loadData();
        },
        data() {
            return {
                roleList: [],
                checkWork: [],
				ipaddress:'',
				ipFlag:false,
				ipList:[],
            }
        },
        methods: {
            async loadData() {
                let that = this;
                let data = {
                    token: that.token
                };
                let res = await getIpAddress(that, data);
                if (res.code == 1) {
					that.ipList = res.data.ipList
                }
            },
            saveIpAddress() {
				let that = this;
                that.throttle(async function () {
                    let data = {
                        token: that.token,
                        ipaddress: that.ipaddress
                    };
                    let res = await saveIpAddress(that, data);
                    if (res.code == 1) {
                        that.$Message.success(res.msg);
                        that.loadData();
                    }
                }, 500)
            },
            editIpAddress(e) {
				let id = e.currentTarget.dataset.id;
				let ipaddress = e.currentTarget.dataset.ipaddress;
				let that = this;
				
				this.$Modal.confirm({
					title: '确认修改ip地址吗？',
					onOk: async () => {
						that.throttle(async function () {
							let data = {
								token: that.token,
								ipaddress: ipaddress,
								id:id
							};
							let res = await saveIpAddress(that, data);
							if (res.code == 1) {
								that.$Message.success(res.msg);
								that.loadData();
							}
						}, 500)
					}
				})

            },
			delIpaddress(e) {
			    let that = this;
			    let id = e.currentTarget.dataset.id;
			    this.$Modal.confirm({
			        title: '确认删除吗？',
			        onOk: async () => {
			            let res = await delIpaddress(that, {token: that.token, id: id});
			            if (res.code == 1) {
			                that.$Message.success(res.msg);
			                that.loadData();
			            }
			        }
			    })
			},


        }
    }
</script>

<style scoped lang="less">
    .multiple {
        display: flex;
        justify-content: left;
        margin-top: 10px;
        align-items: center;

        .child-div {
            width: 300px;
            height: 20px;
            margin-right: 30px;
            font-weight: bold;
        }
    }
    .setMoney{
        display: flex; align-items: center; margin-left: 20px;width: 230px
    }
    .inline{
        display: inline-block;
    }
    .header{
        display: flex;
        justify-content: start;
        padding-top: 50px;
        font-size: 17px;
        font-weight: bold;
        color: #54A1F3;
        .save{
            padding-left: 350px;
        }
    }
</style>
